<template>
  
  <div id="canadas_upstanders_wrapper" >
     <div v-if="canadas_upstanders_section" class="py-5">
          <div class="container">
              <div class="row flex-column justify-content-center">
                <h2 class="h1 text-center">{{ $t(iKey('canadas_upstanders_section', 'canadas_upstanders_section', 'headline')) }}</h2>
                <p class="w-75 explainer2 text-center my-3 align-self-center" v-html="$t(iKey('canadas_upstanders_section', 'canadas_upstanders_section', 'description'))"></p>
        
                <div class="bg-img" v-if="posterImage" 
                    v-lazy:background-image="posterImage">
                </div>
                <div v-else-if="$t(iKey('main_video','video','video_embed'))" class="align-self-center w-100 mt-4">
                  <VideoEmbed 
                    ref="vid_embed"
                    :video_regular="$t(iKey('main_video','video','video_embed'))"
                    :video_descr="$t(iKey('main_video','video','video_desc_embed'))">
                  </VideoEmbed>
                </div>
              
                </div>
              </div>
        </div>
    </div>
  
</template>

<script>
import VideoEmbed from '@/components/ui/VideoEmbed'

export default {
  name: 'CanadasUpstanders',
  components: {
    VideoEmbed
  },
  props: [
    'items',
    'canadas_upstanders_section'
  ],
  computed: {
    posterImage() {
      let up = this.canadas_upstanders_section[0].value
      let img = ""
      try {
        img = up.poster_image.url_resized_large
      } 
      catch(err) {
        img = ""
      }
      return img
    }
  },
  mounted() {
      var dur = this.windowHeight
      const scene = this.$scrollmagic.scene({
          triggerElement: '#canadas_upstanders_wrapper',
          triggerHook: 0,
          duration: dur
      })
      this.$scrollmagic.addScene(
      scene
          .on('leave', () => {
            if(this.$refs.vid_embed){
              this.$refs.vid_embed.stop();
            }
          })
      )
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.guide-text-header {
  background-color: #00b0a8;
  color: #ffffff;
}
.bg-img {
   background-size: cover;
   width: 100%;
   height: 75vh;
   background-position: center;
}
</style>
